var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-wrapper"},[_c('canvas',{ref:"canvas",staticClass:"donut",attrs:{"width":_vm.width,"height":_vm.height}}),_vm._v(" "),_c('span',{staticClass:"darker-text canvas-text"},[_vm._v(_vm._s(_vm.percentage)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }